import React, { useState } from 'react';
import { Dialog } from '@mui/material/';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const customCellHeader = {
  whiteSpace: 'nowrap',
  backgroundColor: 'primary.main',
  color: 'white',
  textAlign: 'center', // จัดข้อความกึ่งกลางแนวนอน
  minWidth: '180px', // กำหนดความกว้างขั้นต่ำ
  width: '200px', // กำหนดความกว้างของเซลล์
  maxWidth: '300px', // กำหนดความกว้างสูงสุด (ไม่ให้เกินขนาดที่กำหนด)
};

function TableDataContact({ open, setOpen, selectedContact, t }) {
  const handleClose = () => {
    setOpen(false);
  };

  const [contactName, setContactName] = useState('');
  const [telephone, setTelephone] = useState('');
  const [email, setEmail] = useState('');
  const [remark, setRemark] = useState('');

  const handleEmailChange = (rowIndex, field, value) => {
    setEmail((preve) => ({
      ...preve,
      [rowIndex]: {
        ...preve[rowIndex],
        [field]: value,
      },
    }));
  };

  const handleRemarkChange = (rowIndex, field, value) => {
    setRemark((preve) => ({
      ...preve,
      [rowIndex]: {
        ...preve[rowIndex],
        [field]: value,
      },
    }));
  };

  const handleContactNameChange = (rowIndex, field, value) => {
    setContactName((prev) => ({
      ...prev,
      [rowIndex]: {
        ...prev[rowIndex],
        [field]: value,
      },
    }));
  };
  const handleTelChange = (rowIndex, field, value) => {
    setTelephone((prev) => ({
      ...prev,
      [rowIndex]: {
        ...prev[rowIndex],
        [field]: value,
      },
    }));
  };
  return (
    <div>
      <Dialog open={open} onClose={null} maxWidth="lg" fullWidth>
        <DialogTitle>
          {t('app.contactInfoDetail')}
          <IconButton
            sx={{
              position: 'absolute',
              top: '8px',
              right: '8px',
            }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ minHeight: '400px', maxHeight: '500px' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={customCellHeader}>
                  {t('app.contactType')}
                </TableCell>
                <TableCell sx={customCellHeader}>
                  {t('app.contactName')}
                </TableCell>
                <TableCell sx={customCellHeader}>{t('app.phone')}</TableCell>
                <TableCell sx={customCellHeader}>{t('app.email')}</TableCell>
                <TableCell sx={customCellHeader}>{t('app.remark')}</TableCell>
              </TableRow>
            </TableHead>
            {_.size(selectedContact) ? (
              <TableBody>
                {selectedContact.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      '&:last-child td, &:last-child th': { border: 0 },
                      height: 40,
                    }}
                  >
                    <TableCell>{row.category}</TableCell>
                    <TableCell>
                      <TextField
                        variant="outlined"
                        size="small"
                        value={contactName[index]?.contact ?? row.contact}
                        onChange={(e) =>
                          handleContactNameChange(
                            index,
                            'contact',
                            e.target.value,
                          )
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        variant="outlined"
                        size="small"
                        value={telephone[index]?.tel ?? row.tel}
                        onChange={(e) =>
                          handleTelChange(index, 'tel', e.target.value)
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        variant="outlined"
                        size="small"
                        value={email[index]?.email ?? row.email}
                        onChange={(e) =>
                          handleEmailChange(index, 'email', e.target.value)
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        variant="outlined"
                        size="small"
                        value={remark[index]?.remark ?? row.remark}
                        onChange={(e) =>
                          handleRemarkChange(index, 'remark', e.target.value)
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={13} align="center">
                    <div>ไม่มีข้อมูล</div>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </DialogContent>
        <div className="flex justify-end">
          <DialogActions>
            <Button color="error" onClick={handleClose}>
              Cancel
            </Button>
          </DialogActions>
          <DialogActions>
            <Button color="primary" onClick={handleClose}>
              Save
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
}

export default TableDataContact;
